export const AUTH_TOKEN = 'AUTH_TOKEN';

export const getAuthToken = () => localStorage.getItem(AUTH_TOKEN);

export const setAuthToken = (authToken: string) => {
  localStorage.setItem(AUTH_TOKEN, authToken);
};

export const clearAuthToken = () => {
  localStorage.removeItem(AUTH_TOKEN);
};